import React from 'react';
import './Class.css';
import class6 from '../../Images/Class-6.png';
import {Helmet} from "react-helmet";


const Class6 = () => (
  <div className="explore-container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Pratham Prayas - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    {/* Back Button */}
    <button className="back-button" onClick={() => window.history.back()}>
      ← Back
    </button>

    {/* Lakshya Card (Right Side, Above Header) */}
    <div className="lakshya-card">
      <img
        src={class6} 
        loading="lazy"
        alt="Lakshya NEET 3.0"
        className="lakshya-image"
      />
      <div className="course-details">
  <p className="pricing">💳 Monthly Fees: ₹ 1199/-</p>
  <p className="pricing">💼 Fees Billed Till Exams: ₹ 5999/-</p>
  <a href="https://rzp.io/rzp/PrathamPrayas" target="_blank" rel="noopener noreferrer">
    <button className="buy-button">Buy Now</button>
  </a>
</div>

    </div>

    {/* Lakshya Header (Full Width) */}
    <div className="lakshya-header">
      <div className="lakshya-header-content">
        <h2 className="lakshya-title">Pratham <span className='highlight'>Prayas</span> (Class-<span className='highlight'>6</span>)</h2>
      </div>
    </div>

    {/* Batch Details Section */}
    <div className="batch-details">
      <h3>Description</h3>
      <ul>
  <li><strong>1️⃣Small Batches for Better Learning</strong>  
    <ul>
      <li>🧑‍🎓 Only 10 students per batch to ensure personalized attention.</li>
    </ul>
  </li>
  <li><strong>2️⃣Subjects Covered</strong>  
    <ul>
      🧮 Mathematics
      🔬 Science
      📖 English
      🌍 Social Science (SST)
      ✍️ Hindi
    </ul>
  </li>
  <li><strong>3️⃣Daily Classes</strong>  
    <ul>
      <li>⏳ Two 1-hour sessions daily with expert tutors to ensure effective learning.</li>
    </ul>
  </li>
  <li><strong>4️⃣24/7 Doubt-Solving Support</strong>  
    <ul>
      <li>💬 Get assistance anytime with round-the-clock doubt-solving.</li>
    </ul>
  </li>
  <li><strong>5️⃣Interactive Live Sessions</strong>  
    <ul>
      <li>🎥 Learn directly from experienced tutors through live classes.</li>
    </ul>
  </li>
  <li><strong>6️⃣Learning Resources</strong>  
    <ul>
      <li>📝 Access class notes, practice sheets, and recorded lectures for easy revision.</li>
    </ul>
  </li>
  <li><strong>7️⃣Interactive Quizzes</strong>  
    <ul>
      <li>🏆 Participate in live quizzes and earn prizes or badges to stay motivated!</li>
    </ul>
  </li>
  <li><strong>8️⃣Weekly PTMs & Progress Reports</strong>  
    <ul>
      <li>📈 Stay connected with your child’s progress through parent-teacher meetings.</li>
    </ul>
  </li>
  <li><strong>9️⃣Weekly Tests</strong>  
    <ul>
      <li>✍️ Regular tests to help improve and track performance.</li>
    </ul>
  </li>
  <li><strong>📩 Have Questions?</strong>  
    <ul>
      <li>Reach out to us at <a href="mailto:support@ottertutors.com">support@ottertutors.com</a></li>
    </ul>
  </li>
  <br/>
  <li><strong>🚀 Join <span className='highlight1'>'Pratham Prayas'</span> Take the first step towards academic success!</strong>  
  </li>
</ul>


    </div>

    {/* FAQ Section */}
    <div className="faq-section">
      <h2>FAQs</h2>
      <p style={{ textAlign: 'center' }}>
  Here are some of the frequently asked questions:
</p>
      <div className="faq-grid">
        <div className="faq-item">
        🎯
          <div>
            <h3> Who Should Join This Batch?</h3>
            <p>
            🎓 Perfect for Class 6 students who are eager to build a strong foundation in subjects and have a thirst for knowledge!
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3> Where Will the Classes Be Held?</h3>
            <p>💻 Classes are conducted on Zoom, and the links will be shared in the WhatsApp group.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>How Can I Get Help If I Have Doubts?</h3>
            <p>💬 24/7 doubt-solving support is available. You can reach out at any time for clarifications.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>What If I Miss a Class?
            </h3>
            <p>
            📼 No worries! All classes are recorded and available for you to review later.

            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Are Tests and Quizzes Mandatory?
            </h3>
            <p>
            ✅ Yes! Weekly tests and live quizzes will help keep track of your progress and improve your skills.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Can I Get a Refund After Batch Purchase?</h3>
            <p>
            💡 Refunds are not allowed after batch purchase due to prior investments in infrastructure and resources. Please make a thoughtful decision.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Class6;
